import React from "react"
import PropTypes from "prop-types"
import { brands, platforms } from "./constants"

const SearchFilter = ({
  selectedColumn="",
  handleColumnSelect=()=>{},
  searchValue="",
  updateSearch=()=>{},
}) => {
  return (
    <div>
      <label htmlFor="column-picker" className="mr-2">
        Choose a column:
      </label>
      <select
        id="column-picker"
        value={selectedColumn}
        onChange={(e) => handleColumnSelect(e.target.value)}
        className="border rounded p-2"
      >
        <option value="">--Select--</option>
        <option value="hiName">Hearing Instrument Name</option>
        <option value="brandDisplayId">Brand Display Id/Name</option>
        <option value="supportsRemoteFitting">Supports Remote Fitting</option>
        <option value="supportsPersistentRemoteTuning">
          Supports Persistent Remote Tuning
        </option>
        <option value="platform">Platform</option>
        <option value="hiTypeId">Hearing Instrument Type ID</option>
      </select>
       <SearchFilterField selectedColumn={selectedColumn} searchValue={searchValue} updateSearch={updateSearch} />
    </div>
  )
}

SearchFilter.propTypes = {
  selectedColumn: PropTypes.string.isRequired,
  handleColumnSelect: PropTypes.func.isRequired,
  searchValue: PropTypes.string.isRequired,
  updateSearch: PropTypes.func.isRequired,
}

const SearchFilterField = ({ selectedColumn, searchValue, updateSearch }) => {
  if (selectedColumn === "supportsRemoteFitting" || selectedColumn === "supportsPersistentRemoteTuning") {
    return (<select
          value={searchValue}
          onChange={(e) => updateSearch(e.target.value)}
          className="border rounded p-2"
        >
          <option value="">--Select--</option>
          <option value="true">true</option>
          <option value="false">false</option>
        </select>)
    } else if (selectedColumn === "platform") {
        return (<select
          value={searchValue}
          onChange={(e) => updateSearch(e.target.value)}
          className="border rounded p-2"
        >
          <option value="">--Select--</option>
          {platforms.map((item) => (
            <option key={item.id} value={item.PlatformId}>
              {item.PlatformId}: {item.PlatformName}
            </option>
          ))}
        </select>)
    }
    else if (selectedColumn === "brandDisplayId") {
        return (<select
          value={searchValue}
          onChange={(e) => updateSearch(e.target.value)}
          className="border rounded p-2"
        >
          <option value="">--Select--</option>
          {brands.map((item) => (
            <option key={item.id} value={item.id}>
              {item.id}: {item.name}
            </option>
          ))}
        </select>)
    }
    else {
        return ((
        <input
          type="text"
          placeholder={`Search by ${selectedColumn}...`}
          value={searchValue}
          onChange={(e) => updateSearch(e.target.value)}
          className="border rounded p-2"
        />))
    }

}

SearchFilterField.propTypes = {
  selectedColumn: PropTypes.string.isRequired,
  searchValue: PropTypes.string.isRequired,
  updateSearch: PropTypes.func.isRequired,
}

export { SearchFilter }
